import {initDatepickerEndToday, swalError, swalSuccessNoButton, swalSuccessWithButton, swalErrorWithActionButton } from "./core";

class Payments {
    // Constructor
    constructor() {
        this.credit();
        this.debit();
        this.cryptoExchangeCredit();
        this.cryptoExchangeDebit();
        this.cryptoNulinkExchangeCredit();
        this.cryptoNulinkExchangeDebit();
        this.cryptoQrModal();
        this.provincialBank();
        this.totalPago();
        this.vesExchange();
        this.debitPayForFunGo();
        this.intervalItem;
    }

    // Credit transactions
    credit(currency) {
        initDatepickerEndToday();
        let $button = $('.credit-transactions');
        let interval;

        $('.credit-transactions-form').keypress(function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
            }
        })

        $button.click(function () {
            let paymentMethod = $(this).data('payment-method');
            let modal = $('#timeout-modal');
            let $form = $('#credit-transactions-form-' + paymentMethod);
            $button.button('loading');

            if(paymentMethod == 48) {
                modal.modal("show");
                let seconds = 65;
                interval = setInterval(function () {
                    seconds--;
                    $('.counter').text(seconds);
                    console.log(seconds);
                    if (seconds === 0) {
                        clearInterval(interval);
                    }
                }, 1000);
            }

            $.ajax({
                url: $form.attr('action'),
                method: 'post',
                data: $form.serialize()

            }).done(function (json) {
                if (paymentMethod == 48) {
                    clearInterval(interval);
                    $('.counter').text('65');
                    modal.modal('hide');
                }
                switch (json.data.type) {
                    case '123pago': {
                        let src = json.data.src.replace('https://payment.123pago.net/msBotonDePago4/css/az.css', '');
                        src = src.replace('https://sandbox.123pago.net/msBotonDePago4/css/az.css', '');
                        src = src.replace('container', 'container d-none');
                        $('#123pago-title').removeClass('d-none');
                        $('#123pago').html(src);
                        break;
                    }
                    case 'monnet': {
                        let request = json.data.request;
                        $('input[name="payinMerchantID"]').val(request.transaction);
                        $('input[name="payinAmount"]').val(json.data.amount);
                        $('input[name="payinMerchantOperationNumber"]').val(request.operation_number);
                        $('input[name="payinVerification"]').val(request.verification);
                        $('input[name="payinExpirationTime"]').val(request.expiration_time);
                        $('input[name="payinLanguage"]').val(request.language);
                        $('input[name="payinProductAmount"]').val(json.data.amount);
                        $('input[name="payinMethod"]').val(request.channel);
                        $('input[name="payinDateTime"]').val(request.date);
                        $('input[name="payinCustomerTypeDocument"]').val(request.type_document);
                        $('input[name="payinCustomerDocument"]').val(request.number_document);
                        $('input[name="URLMonnet"]').val(request.cert_url);
                        $form.attr('action', request.url);
                        $form.submit();
                        break;
                    }
                    case 'coral-commerce': {
                        let data = json.data;
                        $('input[name="PayserverUser"]').val(data.coral_commerce_username);
                        $('input[name="encJSON"]').val(data.encrypted_json);
                        $form.attr('action', data.url);
                        $form.submit();
                        break;
                    }
                    case 'vpos': {
                        let styles = {
                            "form-background-color": "#001b60",
                            "button-background-color": "#4faed1",
                            "button-text-color": "#fcfcfc",
                            "button-border-color": "#dddddd",
                            "input-background-color": "#fcfcfc",
                            "input-text-color": "#111111",
                            "input-placeholder-color": "#111111"
                        };

                        if (json.data.zimple) {
                            Bancard.Zimple.createForm('iframe-container', json.data.process_id, styles);
                        } else {
                            Bancard.Checkout.createForm('iframe-container', json.data.process_id, styles);
                        }

                        setTimeout(() => {
                            $('#deposits-withdrawals-modal').modal('hide');
                            $('#vpos-credit-modal').modal('show');
                        }, 1000);
                        break;
                    }
                    case 'directa24': {
                        let iframe = document.createElement('iframe');
                        iframe.src = json.data.url;
                        document.body.appendChild(iframe);

                        $('#directa24-credit-body-iframe-container').empty();
                        $('#directa24-credit-body-iframe-container').append(iframe);

                        setTimeout(() => {
                            $('#deposits-withdrawals-modal').modal('hide');
                            $('#directa24-credit-modal').modal('show');
                        }, 1000);
                        break;
                    }
                    case 'cripten': {
                        let iframe = document.createElement('iframe');
                        iframe.src = json.data.url;
                        document.body.appendChild(iframe);

                        $('#cripten-credit-body-iframe-container').empty();
                        $('#cripten-credit-body-iframe-container').append(iframe);

                        setTimeout(() => {
                            $('#deposits-withdrawals-modal').modal('hide');
                            $('#cripten-credit-modal').modal('show');
                        }, 1000);
                        break;
                    }
                    case 'dinelco': {
                        let iframe = document.createElement('iframe');
                        iframe.id = 'dinelcoCheckout';
                        iframe.name = 'dinelcoCheckout';
                        iframe.style.width = '100%';
                        iframe.style.height = '680px';
                        iframe.style.border = '1px solid #ddd';

                        $('#dinelco-credit-checkoutForm').attr('action', json.data.validateUrl);
                        $('#dinelco-credit-integrityToken-input').val(json.data.token);

                        $('#dinelco-credit-body-iframe-container').empty();
                        $('#dinelco-credit-body-iframe-container').append(iframe);
                      
                        setTimeout(() => {
                            $('#deposits-withdrawals-modal').modal('hide');
                            $('#dinelco-credit-modal').modal('show');
                        }, 1000);
                        break;
                    }
                    case 'primepag': {
                        // $('#reference').text("").text(json.data.contentPrime);
                        $('.clipboard').val(json.data.contentPrime);
                        $('#qrCode').empty().append("<img src='data:image/png;base64," + json.data.qrCode + "' alt='qrCodePrimepag' width='50%' />");

                        setTimeout(() => {
                            $('#deposits-withdrawals-modal').modal('hide');
                            $('#primepag-credit-modal').modal('show');
                        }, 1000);

                        $(document).on('click', '#copy-clipboard', function () {
                            let clipboard = $(this).closest('.group-items').find('#clipboard').val()

                            if (navigator.clipboard) {
                                navigator.clipboard.writeText(clipboard)
                                .then(() => {
                                    console.log("Copied");
                                })
                                .catch(() => {
                                    console.long("Error");
                                });
                            }
                        })

                        break;
                    }
                    case 'personal_qr': {
                        $('#qrCode').empty().append("<img src='data:image/png;base64," + json.data.image + "' alt='Personal QR' width='50%' />");
                        setTimeout(() => {
                            $('#deposits-withdrawals-modal').modal('hide');
                            $('#personal-qr-credit-modal').modal('show');
                        }, 1000);
                        break;
                    }
                    case 'nulink': {
                        $('.clipboard').val(json.data.wallet_address);
                        $('#token').val(json.data.tokens);
                        setTimeout(() => {
                            $('#deposits-withdrawals-modal').modal('hide');
                            $('#table-nulink-modal').modal('show');
                        }, 1000);
                       
                        $(document).on('click', '#copy-clipboard', function () {
                            let clipboard = $(this).closest('.group-items').find('#clipboard').val()
                            if (navigator.clipboard) {
                                navigator.clipboard.writeText(clipboard)
                                .then(() => {
                                    console.log("Copied");
                                })
                                .catch(() => {
                                    console.long("Error");
                                });
                            }
                        })
                        break;
                    }
                    case 'four_on': {
                        console.log(json.data.iframe);
                        $('#iframe').append(json.data.iframe);
                        $('#deposits-withdrawals-modal').modal('hide');
                        $('#table-4on-modal').modal('show');
                        $(document).on('click', '.close', function () {
                            $('#table-4on-modal').find('#iframe').html('');
                        })
                        break;
                    }
                    case 'pag_smile': {
                        setTimeout(() => {
                            window.open(json.data.route, '_blank');
                        }, 1500);
                        break;
                    }
                    case 'redirect': {
                        swalSuccessNoButton(json);
                        setTimeout(() => {
                            window.open(json.data.route, '_blank');
                        }, 1500);
                        break;
                    }
                    case 'reload': {
                        setTimeout(() => {
                            swalSuccessNoButton(json);
                            window.location.href = json.data.route;
                        }, 1500);
                        break;
                    }
                }
            }).fail(function (json) {
                if (paymentMethod == 48) {
                    clearInterval(interval);
                    $('.counter').text('65');
                    modal.modal('hide');
                }
                swalError(json);
            }).always(function () {
                $button.button('reset');
            });
        });
    };

    // Crypto exchange credit
    cryptoExchangeCredit() {
        $('.crypto-exchange-credit').blur(function () {
            Payments.exchangeCredit();
        });

        $('.cryptocurrency-credit').change(function () {
            Payments.exchangeCredit();
        });
    }

    // Crypto exchange debit
    cryptoExchangeDebit() {
        $('.crypto-exchange-debit').blur(function () {
            Payments.exchangeDebit();
        });

        $('.cryptocurrency-debit').change(function () {
            Payments.exchangeDebit();
        });
    }

    // Crypto Nulink exchange credit
    cryptoNulinkExchangeCredit() {
        $('.nulink-exchange-credit').keyup(function () {
            Payments.exchangeCreditNulink();
        });

        $('.cryptocurrency-nulink-credit').change(function () {
            Payments.exchangeCreditNulink();
        });
    }

    // Crypto Nulink exchange debit
    cryptoNulinkExchangeDebit() {
        $('.nulink-exchange-debit').keyup(function () {
            Payments.exchangeDebitNulink();
        });

        $('.cryptocurrency-nulink-debit').change(function () {
            Payments.exchangeDebitNulink();
        });
    }


    cryptoQrModal(){
        $(document).on('click', '.modal-qr-cryto', function (e) {
            e.preventDefault();
        })
        let $modal = $('#watch-crypto-qr-modal');
        $modal.on('show.bs.modal', function (event) {
            let $target = $(event.relatedTarget);
            $('#qr').append($target.data('qr'));
            $('#data-wallet').append($target.data('wallet'));
            $('#data-cryptocurrency').append($target.data('cryptocurrency'));
        })
        $modal.on('hidden.bs.modal', function () {
            $modal.find('#qr').html('');
            $modal.find('#data-wallet').html('');
            $modal.find('#data-cryptocurrency').html('');
        })

    }

    // Debit transactions
    debit() {
        let $button = $('.debit-transactions');

        $('.debit-transactions-form').keypress(function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
            }
        });

        $button.click(function () {
            let paymentMethod = $(this).data('payment-method');
            let $form = $('#debit-transactions-form-' + paymentMethod);

            // Saldo en wallet bono y/o bonos "por reclamar" en el panel: mostrar confirmación antes del retiro.
            let hasBonusBalance = parseFloat($('#bonus-balance-amount').val() || '0') > 0;
            let pendingClaimableBonuses = parseInt($('#pending-available-bonus-campaigns-count').val() || '0', 10) > 0;

            if (hasBonusBalance || pendingClaimableBonuses) {
                // Guardar referencia al formulario en el modal para usarla al confirmar
                $('#cancel-bonuses-before-withdraw-modal').data('debit-form-selector', '#debit-transactions-form-' + paymentMethod);
                $('#cancel-bonuses-before-withdraw-modal').modal('show');
                return;
            }

            Payments.submitDebitForm($button, $form);
        });

        // Confirmación dentro del modal: cancelar bonos y continuar con el retiro.
        $(document).on('click', '#confirm-cancel-bonuses-before-withdraw', function () {
            let modal = $('#cancel-bonuses-before-withdraw-modal');
            let selector = modal.data('debit-form-selector');
            let $form = selector ? $(selector) : null;
            if (!$form || $form.length === 0) {
                modal.modal('hide');
                return;
            }

            let $button = $('.debit-transactions');
            Payments.submitDebitForm($button, $form, true);
            modal.modal('hide');
        });
    }

    static submitDebitForm($button, $form, cancelBonuses = false) {
        $button.button('loading');

        let formData = $form.serialize();
        if (cancelBonuses) {
            formData += (formData ? '&' : '') + 'cancel_bonuses=1';
        }

        $.ajax({
            url: $form.attr('action'),
            method: 'post',
            data: formData

        }).done(function (json) {
            swalSuccessWithButton(json, function () {
                window.location.reload();
            });

        }).fail(function (json) {
            if (json.responseJSON?.data?.button?.url != null) {
                swalErrorWithActionButton(json);
            } else {
                swalError(json);
            }

        }).always(function () {
            $button.button('reset');
        });
    }

    // Provincial bank
    provincialBank() {
        $('.wire-transfers-client-account').change(function () {
            let $container = $('.wire-transfers-reference-container');
            let $field = $('#wire-transfers-reference');
            let bank = $(this).find('option:selected').data('bank');

            if (bank === 17) {
                $container.addClass('d-none');
                let now = new Date().getTime() / 1000;
                let microTime = parseInt(now, 10);
                $field.val(microTime);

            } else {
                $container.removeClass('d-none');
                $field.val('');
            }
        });

        $('.mobile-payment-client-account').change(function () {
            let $container = $('.mobile-payment-reference-container');
            let $field = $('#mobile-payment-reference');
            let bank = $(this).find('option:selected').data('bank');

            if (bank === 17) {
                $container.addClass('d-none');
                let now = new Date().getTime() / 1000;
                let microTime = parseInt(now, 10);
                $field.val(microTime);

            } else {
                $container.removeClass('d-none');
                $field.val('');
            }
        });
    }

    // Total pago
    totalPago() {
        $('select[name="bank"]').change(function () {
            let value = $(this).val();
            let $table = $('.total-pago-accounts');

            if (value !== '') {
                let $option = $(this).find('option:selected');
                $('#total-pago-social-reason').text($option.data('social-reason'));
                $('#total-pago-dni').text($option.data('dni'));
                $('#total-pago-account').text($option.data('account'));
                $table.removeClass('d-none');
            } else {
                $table.addClass('d-none');
            }

        });
    }

    // VES exchange
    vesExchange() {
        let $amount = $('.ves-to-usd-exchange');
        $amount.keyup(function () {
            $.ajax({
                url: $('.ves-to-usd-form').data('route'),
                method: 'get',
                data: {
                    amount: $(this).val()
                }

            }).done(function (json) {
                $('input[name="usd_amount"]').val(json.data.usd_amount);

            }).fail(function (json) {
                swalError(json);
            });
        });
    }

    // Debit PayForFunGo
    debitPayForFunGo() {
        let $button = $('.debit-transactions-pay-for-fun');

        $('.debit-transactions-form').keypress(function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
            }
        })

        $button.click(function () {
            let paymentMethod = $(this).data('payment-method');
            let $form = $('#debit-transactions-form-' + paymentMethod);
            $button.button('loading');

            $.ajax({
                url: $form.attr('action'),
                method: 'post',
                data: $form.serialize()

            }).done(function (json) {
                swalSuccessNoButton(json);
                setTimeout(() => {
                    window.open(json.data.route, '_blank');
                }, 1500);
            }).fail(function (json) {
                swalError(json);

            }).always(function () {
                $button.button('reset');
            });
        });
    }

    // Exchange credit
    static exchangeCreditNulink() {
        $.ajax({
            url: $('.nulink-form').data('route'),
            method: 'get',
            data: {
                amount: $('.nulink-exchange-credit').val(),
                cryptocurrency: $('.cryptocurrency-nulink-credit').val()
            }

        }).done(function (json) {
            $('.crypto-nulink-amount-credit').val(json.data.cryptocurrency_amount);

        }).fail(function (json) {
            swalError(json);
        });
    }

    // Exchange debit
    static exchangeDebitNulink() {
        $.ajax({
            url: $('.nulink-form').data('route'),
            method: 'get',
            data: {
                amount: $('.nulink-exchange-debit').val(),
                cryptocurrency: $('.cryptocurrency-nulink-debit').val()
            }

        }).done(function (json) {
            $('.crypto-nulink-amount-debit').val(json.data.cryptocurrency_amount);

        }).fail(function (json) {
            swalError(json);
        });
    }

     // Exchange credit
     static exchangeCredit() {
        $.ajax({
            url: $('.cryptocurrencies-form').data('route'),
            method: 'get',
            data: {
                amount: $('.crypto-exchange-credit').val(),
                cryptocurrency: $('.cryptocurrency-credit').val()
            }

        }).done(function (json) {
            $('.crypto-amount-credit').val(json.data.cryptocurrency_amount);

        }).fail(function (json) {
            swalError(json);
        });
    }

    // Exchange debit
    static exchangeDebit() {
        $.ajax({
            url: $('.cryptocurrencies-form').data('route'),
            method: 'get',
            data: {
                amount: $('.crypto-exchange-debit').val(),
                cryptocurrency: $('.cryptocurrency-debit').val()
            }

        }).done(function (json) {
            $('.crypto-amount-debit').val(json.data.cryptocurrency_amount);

        }).fail(function (json) {
            swalError(json);
        });
    }

    static timeoutCounter(targetCounter, time, callFunction) {
        let target = $(targetCounter)
        target.text(time)

        setTimeout(() => {
            this.intervalItem = setInterval(() => {
                let counterTime = parseInt(target.text())

                if (parseInt(target.text()) > 0) {
                    target.text(counterTime - 1)
                    console.log(counterTime);
                } else {
                    clearInterval(this.intervalItem);

                    // En caso de querer que el contador haga un call a otra función (hay que probar si funciona)
                    if (callFunction) {
                        callFuntion()
                    }
                }
            }, 1000);
        }, 1000);
    }
}

window.Payments = Payments;